module.exports = __webpack_public_path__ + "static/media/file_placeholder.be25e53e.svg";